// src/helpers/rutaReportes.js
const BASES = [
  "http://backdanlu.eu-4.evennode.com",   // dev: sin SSL
  "https://backdanlu.eu-4.evennode.com",  // si más adelante renuevan el SSL
];

export async function getSaldoCliente(clienteId, fechaISO) {
  if (!clienteId) return { ok: false, error: "clienteId requerido" };
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";

  let lastErr;
  for (const base of BASES) {
    const url = `${base.replace(/\/$/,"")}/reportes/saldo-cliente/${clienteId}${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        // credentials: "include", // habilitar solo si usás cookies cross-site
      });

      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = { ok:false, error: json?.error || `HTTP ${r.status}`, tried: url };
        continue;
      }

      // ---- Normalizadores ----
      const toNum  = n => Number(n || 0);
      const toDate = d => (d ? new Date(d) : null);
      const toStr  = v => (v == null ? "" : String(v));

      return {
        ok: true,
        clienteId: json.clienteId,
        fechaCorte: toDate(json.fechaCorte),
        totalSaldoComandas: toNum(json.totalSaldoComandas),

        comandasConSaldo: (json.comandasConSaldo || []).map(i => ({
          ...i,
          // alias robustos (ESTAS claves pisan lo que venga en ...i)
          numero:   toStr(i.numero   ?? i.codcom ?? i.nrodecomanda ?? i.num ?? ""),
          nroviaje: toStr(
            i.nroviaje ?? i.nroViaje ?? i.nro_viaje ??
            i.nro ?? i.nrovia ?? i.nro_via ?? i.nroVia ?? ""
          ),
          fecha:    toDate(i.fecha),
          total:    toNum(i.total),
          aplicado: toNum(i.aplicado),
          saldo:    toNum(i.saldo),
        })),

        ordenesCobroAbiertas: (json.ordenesCobroAbiertas || []).map(i => ({
          ...i,
          total: toNum(i.total),
          fecha: toDate(i.fecha),
        })),
      };


    } catch (e) {
      lastErr = { ok:false, error: e?.message || e, tried: url };
      // si falló https por SSL, el primer base http debería funcionar en dev
      continue;
    }
  }

  console.error("[getSaldoCliente] fallo en todas las bases:", lastErr);
  return { ok: false, error: "No se pudo conectar con el servidor de reportes." };
}

export function toISODate(dateLike) {
  if (!dateLike) return "";
  const d = new Date(dateLike);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

export async function getCtaCteEntidad({ tipo, id, desde, hasta }) {
  if (!id) return { ok: false, error: "id requerido" };
  if (!desde || !hasta) return { ok: false, error: "desde/hasta requeridos" };

  const token = localStorage.getItem("token") || ""; // 👈 tu app usa header token
  const params = new URLSearchParams({
    tipo: String(tipo || "CLIENTE").toUpperCase(),
    id,
    desde,
    hasta,
  }).toString();

  let lastErr;

  for (const base of BASES) {
    const url = `${base.replace(/\/$/, "")}/reportes/ctacte-entidad?${params}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { token } : {}),
        },
      });

      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = {
          ok: false,
          error: json?.error || `HTTP ${r.status}`,
          tried: url,
        };
        continue;
      }

      // ---- Normalizadores (igual estilo al tuyo) ----
      const toNum = (n) => Number(n || 0);
      const toDate = (d) => (d ? new Date(d) : null);
      const toStr = (v) => (v == null ? "" : String(v));

      return {
        ok: true,
        entidad: json.entidad || {},
        saldoInicial: { saldo: toNum(json?.saldoInicial?.saldo) },
        totalesPeriodo: {
          debe: toNum(json?.totalesPeriodo?.debe),
          haber: toNum(json?.totalesPeriodo?.haber),
          pactadoBruto: toNum(json?.totalesPeriodo?.pactadoBruto),
          comision: toNum(json?.totalesPeriodo?.comision),
          merma: toNum(json?.totalesPeriodo?.merma),
        },
        saldoFinal: { saldo: toNum(json?.saldoFinal?.saldo) },

        movimientos: (json.movimientos || []).map((m) => ({
          ...m,
          fecha: toDate(m.fecha),
          fechaYMD: toStr(m.fechaYMD),
          nroviaje: toStr(m.nroviaje), // ✅ NUEVO
          comprobante: toStr(m.comprobante),
          concepto: toStr(m.concepto),
          kind: toStr(m.kind),

          // importes
          debe: toNum(m.debe),
          haber: toNum(m.haber),
          saldo: toNum(m.saldo),

          // extras opcionales (por si tu tabla/pdf los usa)
          nroFac: toStr(m.nroFac),
          choferNombre: toStr(m.choferNombre),
          kgRecibido: toNum(m.kgRecibido),
          precio: toNum(m.precio),
        })),
      };
    } catch (e) {
      lastErr = { ok: false, error: e?.message || e, tried: url };
      continue;
    }
  }

  console.error("[getCtaCteEntidad] fallo en todas las bases:", lastErr);
  return { ok: false, error: "No se pudo conectar con el servidor de reportes." };
}

export async function getSaldosCliTra(fechaISO) {
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";
  const token = localStorage.getItem("token") || "";

  let lastErr;
  for (const base of BASES) {
    const url = `${base.replace(/\/$/,"")}/reportes/saldos-cli-tra${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json", token },
      });
      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = { ok:false, error: json?.error || json?.msg || `HTTP ${r.status}`, tried: url };
        continue;
      }
      return json;
    } catch (e) {
      lastErr = { ok:false, error: e?.message || e, tried: url };
      continue;
    }
  }
  console.error("[getSaldosCliTra] fallo:", lastErr);
  return { ok: false, error: "No se pudo conectar con el servidor." };
}

export async function getInformeCliPro(fechaISO) {
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";

  let lastErr;
  for (const base of BASES) {
    const url = `${base.replace(/\/$/,"")}/reportes/saldos-cli-tra${q}`;
    try {
      const r = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token") || "",
        },
      });
      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = json;
        continue;
      }
      return json;
    } catch (e) {
      lastErr = e;
    }
  }
  return { ok: false, error: lastErr?.error || lastErr?.message || "No se pudo conectar." };
}

export async function getInformeChoferes(fechaISO) {
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";
  const token = localStorage.getItem("token") || "";

  let lastErr;

  for (const base of BASES) {
    const url = `${base.replace(/\/$/, "")}/reportes/informe-choferes${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { token } : {}),
        },
      });

      const json = await r.json().catch(() => ({}));

      if (!r.ok || json?.ok === false) {
        lastErr = {
          ok: false,
          error: json?.error || json?.msg || `HTTP ${r.status}`,
          tried: url,
        };
        continue;
      }

      const toNum = (n) => Number(n || 0);
      const toStr = (v) => (v == null ? "" : String(v));

      return {
        ok: true,
        fechaCorte: toStr(json?.fechaCorte || fechaISO || ""),
        totales: {
          liquidado: toNum(json?.totales?.liquidado),
          pagado: toNum(json?.totales?.pagado),
          pendiente: toNum(json?.totales?.pendiente),
        },
        choferes: (json?.choferes || []).map((c) => ({
          ...c,
          _id: toStr(c?._id),
          nombre: toStr(c?.nombre),
          viajes: toNum(c?.viajes),
          totalLiquidado: toNum(c?.totalLiquidado),
          totalPagado: toNum(c?.totalPagado),
          saldo: toNum(c?.saldo),
        })),
      };
    } catch (e) {
      lastErr = { ok: false, error: e?.message || e, tried: url };
      continue;
    }
  }

  console.error("[getInformeChoferes] fallo:", lastErr);
  return {
    ok: false,
    error: "No se pudo conectar con el servidor de reportes.",
  };
}

export async function getInformeEstaciones(fechaISO) {
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";
  const token = localStorage.getItem("token") || "";

  let lastErr;

  for (const base of BASES) {
    const url = `${base.replace(/\/$/, "")}/reportes/saldos-estaciones${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { token } : {}),
        },
      });

      const json = await r.json().catch(() => ({}));

      if (!r.ok || json?.ok === false) {
        lastErr = {
          ok: false,
          error: json?.error || json?.msg || `HTTP ${r.status}`,
          tried: url,
        };
        continue;
      }

      return json;
    } catch (e) {
      lastErr = { ok: false, error: e?.message || e, tried: url };
      continue;
    }
  }

  console.error("[getInformeEstaciones] fallo:", lastErr);
  return {
    ok: false,
    error: "No se pudo conectar con el servidor de reportes.",
  };
}

export async function getRentabilidadTransporte({
  transporteId,
  desde,
  hasta,
}) {
  if (!transporteId || !desde || !hasta) {
    return {
      ok: false,
      error: "Seleccione transporte y fechas.",
    };
  }

  const base =
    process.env.REACT_APP_API ||
    "https://backdanlu.eu-4.evennode.com";

  const params = new URLSearchParams({
    transporteId,
    desde,
    hasta,
  });

  try {
    const respuesta = await fetch(
      `${base.replace(/\/+$/, "")}` +
        `/reportes/rentabilidad-transporte?${params}`,
      {
        headers: {
          token: localStorage.getItem("token") || "",
        },
      }
    );

    const data = await respuesta.json();

    if (!respuesta.ok || data?.ok !== true) {
      return {
        ok: false,
        error:
          data?.error ||
          data?.msg ||
          `Error HTTP ${respuesta.status}`,
      };
    }

    return data;
  } catch (error) {
    return {
      ok: false,
      error:
        error.message ||
        "No se pudo conectar con el servidor.",
    };
  }
}